import { style } from '@vanilla-extract/css';

export const fullscreenPage = style({
  position: 'relative',
  width: '100%',
  height: '100%',
  overflow: 'hidden',
  isolation: 'isolate',
});
